export { default } from './isImmutableKeyedSeq'
